import { render, staticRenderFns } from "./PollutionalertsGrid.vue?vue&type=template&id=1deac4cc"
import script from "./PollutionalertsGrid.vue?vue&type=script&lang=js"
export * from "./PollutionalertsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports